export * from './department-carousel-item';
export * from './department-carousel-item-bottom';
export * from './department-details';

import { DepartmentCarouselItemComponent } from './department-carousel-item';
import { DepartmentCarouselItemBottomComponent } from './department-carousel-item-bottom';
import { DepartmentDetailsComponent } from './department-details';


export const DepartmentAtoms = [
    DepartmentCarouselItemComponent,
    DepartmentCarouselItemBottomComponent,
    DepartmentDetailsComponent,
]